// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"145":"71913b56","475":"ebefed25","701":"693c354c","867":"fb6379a3"}[chunkId] + ".css";
};